"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDataAccessConfig = exports.createNumberJsFormatter = void 0;
var tslib_1 = require("tslib");
var numberjs_1 = require("@gooddata/numberjs");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var escape_1 = tslib_1.__importDefault(require("lodash/escape"));
var unescape_1 = tslib_1.__importDefault(require("lodash/unescape"));
var customEscape = function (str) { return str && escape_1.default(unescape_1.default(str)); };
/**
 * Creates value formatter that uses `@gooddata/numberjs` to format raw measure values according
 * to the format string.
 *
 * @remarks
 * By default, the format will strip away all the coloring information and
 * just return the value as string.
 *
 * @param separators - number separators to use. if not specified then `numberjs` defaults will be used
 * @public
 */
function createNumberJsFormatter(separators) {
    return function (value, format) {
        var valueToFormat = value === null && !isEmpty_1.default(format) ? "" : parseFloat(value);
        var formattedValue = numberjs_1.numberFormat(valueToFormat, format, undefined, separators);
        var formattedObject = numberjs_1.colors2Object(formattedValue);
        return customEscape(formattedObject.label);
    };
}
exports.createNumberJsFormatter = createNumberJsFormatter;
/**
 * Default configuration for the data access methods. Uses default `@gooddata/numberjs` formatter and no result formatting.
 *
 * @public
 */
exports.DefaultDataAccessConfig = {
    valueFormatter: createNumberJsFormatter(),
};
//# sourceMappingURL=dataAccessConfig.js.map